export const dueDateFilter = Object.freeze({
  DUE_DATE_TODAY: 'dueDateToday',
  DUE_DATE_THIS_WEEK: 'dueDateThisWeek',
  DUE_DATE_NEXT_WEEK: 'dueDateNextWeek',
  DUE_DATE_THIS_MONTH: 'dueDateThisMonth',
  DUE_DATE_NEXT_MONTH: 'dueDateNextMonth',
  WITHOUT_DUE_DATE: 'withoutDueDate',
  DUE_DATE_OVERDUE: 'dueDateOverdue'
})
